import React from 'react';
import { Typography } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { ActionIcon } from '@mummssoftware/common-ui';
import { SingleTaskPlanner } from './SingleTaskPlanner';
import { ReadOnlySingleTaskPlanner } from './ReadOnlySingleTaskPlanner';
import { useStyles } from './style';
import { isTaskSelected } from './utils';
import { Other } from '../CPPEngine/constants';
import { Rendering } from '../Context/constants';
import {
  TaskPlannerDiv,
  TasksDiv,
  TaskDiv,
} from '../../components/layout/WrapperDiv';
import defaults from '../../translations/en.json';

type TaskPlannerProps = {
  tasks: mumms.PatientCppTask[] | null;
  readOnly?: boolean;
  previewMode?: boolean;
  type?: mumms.CPPType;
};

export const TaskPlanner = ({
  tasks,
  readOnly,
  previewMode,
  type,
}: TaskPlannerProps) => {
  const classes = useStyles();

  const toDisplayTasks =
    type === Rendering
      ? tasks &&
        tasks.length &&
        tasks.filter((el: any) => el.tasktext !== Other)
      : tasks;

  const readView = readOnly || previewMode;

  const getReadTitle = () => (
    <TaskDiv>
      <ActionIcon
        style={{
          margin: 0,
        }}
        Icon={ExpandMoreIcon}
      />
      <Typography variant="body1" className={classes.readTitle}>
        {defaults.patientTasks}
      </Typography>
    </TaskDiv>
  );

  const getUI = () =>
    toDisplayTasks ? (
      <TaskPlannerDiv id="task-planner">
        <TasksDiv>
          {toDisplayTasks.map((task: mumms.PatientCppTask) => (
            <SingleTaskPlanner task={task} key={task.id} />
          ))}
        </TasksDiv>
      </TaskPlannerDiv>
    ) : (
      <></>
    );

  const getReadOnlyUI = () => {
    const isSelected =
      tasks && tasks.length && tasks.filter((el: any) => isTaskSelected(el));
    return isSelected && isSelected.length ? (
      <TaskPlannerDiv id="read-task-planner" readonly>
        {getReadTitle()}
        <TasksDiv>
          {isSelected.map((task: mumms.PatientCppTask) => (
            <ReadOnlySingleTaskPlanner task={task} key={task.id} />
          ))}
        </TasksDiv>
      </TaskPlannerDiv>
    ) : (
      <></>
    );
  };

  return <>{readView ? getReadOnlyUI() : getUI()}</>;
};
